export default "/spinner.a8f24f53c819b1be93cc538ae488554d.svg";